import { render, staticRenderFns } from "./XomeCpu.vue?vue&type=template&id=de482e66&"
import script from "./XomeCpu.vue?vue&type=script&lang=js&"
export * from "./XomeCpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports